import { render, staticRenderFns } from "./Agentalll.vue?vue&type=template&id=0e12b4ba"
import script from "./Agentalll.vue?vue&type=script&lang=js"
export * from "./Agentalll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports